import { actions } from './actions';
import { getters } from './getters';
import { mutations } from './mutations';
export var state = {
    loading: {},
    pages: {},
};
export var landingPages = {
    namespaced: true,
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations,
};
